<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Anomalies Souscripteur (contrats ouverts) </strong>
      </b-card-header>
      <b-card-body>
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          class="export-excel-btn mb-2"
          :filename="'export_anomalies_souscripteur_'+getTimestamp()">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </vue-excel-xlsx>
        <table v-if="finished" class="mt-2" border="1px">
          <thead>
          <tr>
            <td class="prune-medium center p-2"><b>SIREN</b></td>
            <td class="prune-medium center p-2"><b>Raison Soaciale</b></td>
            <td class="prune-medium p-2"><b>Contrats en Anomalie</b></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in anomalieSouscripteur" :key="key">
            <td class="p-2"> {{ element.siren }}</td>
            <td class="p-2"> {{ element.raison_sociale }}</td>
            <td class="p-2"> {{ removeTrailingComa(element.num_contrat_coll) }}</td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "AnomalieSouscripteur",
    data() {
      return {
        anomalieSouscripteur: [],
        finished: false,
        excelColumns: [
          {
            label: "SIREN",
            field: "siren",
          },
          {
            label: "Raison sociale",
            field: "raisonSociale",
          },
          {
            label: "Contrats en Anomalie",
            field: "contrat",
          },
        ],
        excelData: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.downloadAnomalieSouscripteur();
    },
    methods: {
      downloadAnomalieSouscripteur() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/extractions/anomalie_souscripteur')
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.anomalieSouscripteur = response.data.data;
            // console.log(response.data.data)
            this.finished = true;
            // console.log(response.data.data[0].num_contrat_coll.replace(/,\s*$/, ''))
            for (let row of response.data.data) {
              this.excelData.push({
                siren: row.siren,
                raisonSociale: row.raison_sociale,
                contrat: this.removeTrailingComa(row.num_contrat_coll)
              });
            }
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
      removeTrailingComa(str) {
        return str.replace(/,\s*$/, '');
      },
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>

